import React, { FC } from "react";
import classnames from "classnames";

import styles from "./grid-row.module.scss";
import { GeneralProps } from "components/shared/types";

export type GapValue = "xsm" | "sm" | "md" | "lg" | "xlg" | "xxlg";

type Props = {
  /**
   * Top spacing
   */
  top?: GapValue;
  /**
   * Bottom spacing
   */
  bottom?: GapValue;
  /**
   * Elements alignment
   */
  alignItems?: "flex-start" | "center" | "flex-end" | "stretch" | "baseline";
  /**
   * Elements justify
   */
  justifyContent?:
    | "flex-start"
    | "center"
    | "flex-end"
    | "space-between"
    | "space-around"
    | "space-evenly";
} & GeneralProps;

export const GridRow: FC<React.PropsWithChildren<Props>> = (props) => {
  const { top, bottom, alignItems, justifyContent, dataQa } = props;

  const className = classnames({
    [styles.root]: true,
    [styles[`top-${top}`]]: top,
    [styles[`bottom-${bottom}`]]: bottom,
    [styles[`align-items-${alignItems}`]]: Boolean(alignItems),
    [styles[`justify-content-${justifyContent}`]]: Boolean(justifyContent),
  });

  return (
    <div className={className} {...dataQa}>
      {props.children}
    </div>
  );
};
